import script from "./ToolbarMunicipal.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarMunicipal.vue?vue&type=script&setup=true&lang=js"

import "./ToolbarMunicipal.vue?vue&type=style&index=0&id=7bdc6cad&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bdc6cad"]])

export default __exports__